import { memo } from 'react'
import {
  BaseEdge,
  EdgeLabelRenderer,
  getBezierPath,
  type Edge,
  type EdgeProps,
} from '@xyflow/react'
import { getEdgeColor, getEdgeWidth, type RelationEdgeData } from '@/utils/graph-data'

function MemoryRelationEdgeComponent({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  selected,
}: EdgeProps<Edge<RelationEdgeData>>) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  })

  const color = getEdgeColor(data?.relationship_type, data?.relation_type)
  const strokeWidth = getEdgeWidth(data?.strength)
  const isDashed = Boolean(data?.isEntityEdge || data?.relationship_type)
  const label = data?.label

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        style={{
          stroke: color,
          strokeWidth: selected ? strokeWidth + 1 : strokeWidth,
          strokeDasharray: isDashed ? '6 4' : undefined,
        }}
        markerEnd={`url(#${id}-arrow)`}
      />
      <defs>
        <marker
          id={`${id}-arrow`}
          markerWidth="8"
          markerHeight="8"
          refX="6"
          refY="4"
          orient="auto"
          markerUnits="strokeWidth"
        >
          <path d="M0,0 L8,4 L0,8 Z" fill={color} />
        </marker>
      </defs>
      {label && !data?.isEntityEdge ? (
        <EdgeLabelRenderer>
          <div
            className="pointer-events-none absolute rounded bg-background/90 px-1 text-[9px] text-muted-foreground shadow-sm"
            style={{
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
            }}
          >
            {label}
          </div>
        </EdgeLabelRenderer>
      ) : null}
    </>
  )
}

export const MemoryRelationEdge = memo(MemoryRelationEdgeComponent)
